export const loadMoreItemsStub = async () => undefined;
